import { useNavigate } from "react-router-dom";
import { Input, Table, Button } from 'antd'

import useEquipments from '../../hooks/equipments/useEquipments';

const { Search } = Input;

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',

  },
  {
    title: 'Serial Number',
    dataIndex: 'serialNumber',

  },
  {
    title: 'Type',
    dataIndex: 'equipmentType',

  },
  {
    title: 'Account',
    dataIndex: 'accountName',

  },
];

function Equipments() {
  const equipmentsQuery = useEquipments();
  const navigate = useNavigate();

  let equipmentsData;

  if(!equipmentsQuery.isLoading){
    equipmentsData = equipmentsQuery.data.map((equipment => { return {...equipment, equipmentType: equipment.equipmentType.name, accountName: equipment.account.name }}));
  }

  return (
    <>
      <h1>Equipments</h1>
      <Button type="primary" onClick={() => navigate('/equipments/new')} >New</Button>
      <div style={{ padding: 24, background: '#f0f2f5', marginTop: 12}}>
        <Search
          placeholder='Pesquisar'
        />
        <Table 
          style={{ marginTop: 24, minHeight: 500}} 
          columns={columns}
          rowKey={record => record.id}
          dataSource={equipmentsData}
          loading={equipmentsQuery.isLoading}
          onRow={(record) => {
            return {
              onClick: () => { navigate(`/equipments/${record.id}`);},
            }}}
        />
      </div>
    </>
  );
}

export default Equipments